import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar"; // Import Sidebar

function Login() {
  const [Id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null); // User state
  const navigate = useNavigate();

  useEffect(() => {
    // Get user from localStorage if already logged in
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Admin login
      if (Id === "ADMIN123" && password === "Strong@Pass123") {
        localStorage.setItem("user", JSON.stringify({ role: "admin" }));
        setUser({ role: "admin" });
        navigate("/admin/dashboard");
        return;
      }

      // Normal user login
      const res = await axios.post("http://localhost:5000/auth/login", { Id, password });

      localStorage.setItem("user", JSON.stringify(res.data.member));
      setUser(res.data.member);
      navigate("/dashboard");
    } catch (err) {
      alert("❌ " + (err.response?.data?.error || "Login failed"));
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
  {/* Sidebar */}
  <Sidebar user={user} setUser={setUser} />

  {/* Login Form */}
  <div style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
    <div style={styles.card}>
      <h1 style={{ textAlign: "center", marginBottom: "20px", color: "red"}}> Login</h1>
      <form onSubmit={handleLogin} style={styles.form}>
        <input
          type="text"
          placeholder="A-ID"
          value={Id}
          onChange={(e) => setId(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button}>Login</button>
      </form>
    </div>
  </div>
</div>
  );
}
const styles = {
  card: {
    backgroundColor: "#86b7c2ff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(220, 207, 207, 0.15)",
    width: "300px",
    textAlign: "center",
    border: "1px solid #c5c7c5ff", // green border like success
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
  },
  input: {
    padding: "10px",
    width: "50%",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#27ae60", // green success color
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default Login;
